import { Button, Modal, ModalBody } from "@ht/components";
import { FC } from "react";
import SuccessIcon from "@ht/shared/fonts/deos-pis/msg-success";
import WarningIcon from "@ht/shared/fonts/deos-pis/msg-warning";
import ErrorIcon from "@ht/shared/fonts/deos-pis/msg-error";

export const MessageBox: FC<{
    type: "warning" | "success" | "error",
    visible: boolean, title: string, message: string,
    closeHandler: () => void;
}> = ({ type, visible, closeHandler, title, message }) => {
    return (
        <Modal show={visible} size="sm" >
            <ModalBody className="!p-5 flex items-center justify-center flex-col">
                <div className="mb-6 self-center" >
                    {type == "error" && <ErrorIcon className="text-red-900" />}
                    {type == "warning" && <WarningIcon className="text-yellow-900" />}
                    {type == "success" && <SuccessIcon className="text-primary" />}
                </div>
                <div className="text-[16px] font-bold text-gray-700">{title}</div>
                <div className="text-md mt-[6px] text-gray-400 text-center">{message}</div>
                <div className="w-full mt-6">
                    <Button shape="rounded" className="h-10 rounded-lg w-full !text-md !font-bold" color="primary" onClick={closeHandler}>Okay</Button>
                </div>
            </ModalBody>
        </Modal>
    );
}